import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function SectionTransition() {
  const {
    t
  } = useLanguage();
  const totalServices = t.services.categories.reduce((sum, category) => sum + category.rows.length, 0);
  const words = t.transition.words;
  const stats = [t.transition.stats.precision, {
    value: `${totalServices}+`,
    label: t.transition.stats.services.label
  }, t.transition.stats.humanHair, t.transition.stats.hairTypes];
  return <section aria-label={t.a11y.logo} className="w-full overflow-hidden bg-ink-900 py-14 sm:py-16" data-id="element-317" data-mp="1lnwvyuuzcq86">
      <div className="gold-rule h-px w-full" aria-hidden="true" data-id="element-318" data-mp="1gx6s5m27cvfl" />

      <div className="relative flex overflow-hidden py-7" data-id="element-319" data-mp="1gvdlw7vi4d84">
        <div className="marquee-x flex shrink-0 items-center gap-10 pr-10" aria-hidden="true" data-id="element-320" data-mp="1byvh58068evs">
          {[...words, ...words].map((word, index) => <span key={`${word}-${index}`} className="flex shrink-0 items-center gap-10" data-id="element-321" data-mp="29esmzprm3hed" data-mpi={index}>
              <span className="font-display text-2xl tracking-[0.18em] text-gold-warm/80 sm:text-3xl" data-id="element-322" data-mp="24l7yqpftm1sd">
                {word}
              </span>
              <span className="text-xs text-gold-deep" data-id="element-323" data-mp="voibzyiwkm3v">◆</span>
            </span>)}
        </div>
        <div className="marquee-x flex shrink-0 items-center gap-10 pr-10" aria-hidden="true" data-id="element-324" data-mp="h05egx462v79">
          {[...words, ...words].map((word, index) => <span key={`dup-${word}-${index}`} className="flex shrink-0 items-center gap-10" data-id="element-325" data-mp="lxnq4v9kjoiy" data-mpi={index}>
              <span className="font-display text-2xl tracking-[0.18em] text-gold-warm/80 sm:text-3xl" data-id="element-326" data-mp="7y4g1wx76340">
                {word}
              </span>
              <span className="text-xs text-gold-deep" data-id="element-327" data-mp="byg2nf94edi4">◆</span>
            </span>)}
        </div>
      </div>

      <div className="gold-rule h-px w-full" aria-hidden="true" data-id="element-328" data-mp="302zpjr5ohw8" />

      <dl className="mx-auto mt-12 grid max-w-5xl grid-cols-2 gap-y-10 px-5 sm:px-8 lg:grid-cols-4 lg:divide-x lg:divide-gold-deep/25" data-id="element-329" data-mp="30mfoux8ww7m">
        {stats.map(stat => <div key={stat.label} className="px-2 text-center" data-id="element-330" data-mp="1xeng3k8g1r9t">
            <dt className="sr-only" data-id="element-331" data-mp="1xbrijx0id4lw">{stat.label}</dt>
            <dd data-id="element-332" data-mp="1vxzuku3yvuvd">
              <span className="block font-display text-4xl leading-none text-gold-bright sm:text-5xl" data-id="element-333" data-mp="1vyjfmjowyzdm">
                {stat.value}
              </span>
              <span className="mt-3 block text-[10px] uppercase tracking-widest2 text-neutral-500" data-id="element-334" data-mp="1lyiq2g0gbn0z">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}